// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

var backgroundColor = Theme__Color$PrezzeeRibbon.Business.stone;

var Theme_logoBlockMargin = {
  NAME: "rem",
  VAL: 3
};

var Theme = {
  backgroundColor: backgroundColor,
  logoPosition: "flexStart",
  logoBlockMargin: Theme_logoBlockMargin
};

export {
  Theme ,
}
/* Theme__Color-PrezzeeRibbon Not a pure module */
